function ActiveIntegrationsTimeRangeFilters() {
  const timeRanges = [
    'Last 7 Days',
    'Last 14 Days',
    'Last 30 Days',
    'Last Year',
    'All Time',
  ];
  const selected = timeRanges[0];
  return (
    <div className="flex flex-row py-2 mb-2 text-base font-medium text-gray-600">
      <div className="flex flex-col flex-start">Show data for:</div>
      <div className="flex flex-col grow">
        <div className="flex flex-row ">
          {timeRanges.map((x) => {
            return (
              <div
                key={x}
                className={`mx-2 flex rounded ${
                  x === selected ? 'bg-blue-400 text-white' : ''
                }  flex-row  grow `}>
                <div
                  className={`${
                    x == 'All Time' ? 'border-l-2 border-gray-200' : ''
                  } flex flex-col justify-center text-center w-full`}>
                  {x}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ActiveIntegrationsTimeRangeFilters;
